import FeeDetails from './fee-details.vue';

export default FeeDetails;
